import axios from '@/axios'


export const fetchMaturityIndustry = async (industrtId) => {
  return await axios.get(`/api/maturity-industry/${industrtId}`)
}